import React, { useEffect, useRef } from 'react';
import Chartist from 'chartist';
import 'chartist/dist/chartist.min.css';
import PropTypes from 'prop-types';

const MacroDonutChart = ({
  proteinPercentage,
  fatPercentage,
  carbsPercentage,
  missingPercentage,
  chartId = 'default',
  donutWidth = 12,
  options = {},
}) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chartistDefaultOptions = {
      donut: true,
      donutWidth: donutWidth,
      donutSolid: true,
      showLabel: false,
      chartPadding: 0,
    };
    const updateChart = () => {
      // Chartist.js struktura danych dla pie chart
      const data = {
        series: [proteinPercentage, fatPercentage, carbsPercentage, missingPercentage],
      };

      // Usuń poprzedni wykres jeśli istnieje
      if (chartRef.current) {
        chartRef.current.detach();
      }

      const chart = new Chartist.Pie(`.ct-macro-chart-${chartId}`, data, {
        ...chartistDefaultOptions,
        ...options,
      });

      // Aplikuj klasy CSS do poszczególnych segmentów
      chart.on('draw', (data) => {
        if (data.type === 'slice') {
          const classes = [
            'ct-series-protein',
            'ct-series-fat',
            'ct-series-carbs',
            'ct-series-total',
          ];
          if (classes[data.index]) {
            data.element.addClass(classes[data.index]);
          }
        }
      });

      chartRef.current = chart;
    };

    updateChart();

    // Cleanup function
    return () => {
      if (chartRef.current) {
        chartRef.current.detach();
      }
    };
  }, [proteinPercentage, fatPercentage, carbsPercentage, missingPercentage, chartId, options]);

  return (
    <div className="macro-donut-chart">
      <div className={`ct-macro-chart-${chartId} ct-chart ct-square`} />
    </div>
  );
};

MacroDonutChart.propTypes = {
  proteinPercentage: PropTypes.number.isRequired,
  fatPercentage: PropTypes.number.isRequired,
  carbsPercentage: PropTypes.number.isRequired,
  missingPercentage: PropTypes.number.isRequired,
  chartId: PropTypes.string,
  options: PropTypes.object,
};

export default React.memo(MacroDonutChart);
